import { render } from "./ProfileOverview.vue?vue&type=template&id=8d2163b0&scoped=true&ts=true"
import script from "./ProfileOverview.vue?vue&type=script&lang=ts"
export * from "./ProfileOverview.vue?vue&type=script&lang=ts"

import "./ProfileOverview.vue?vue&type=style&index=0&id=8d2163b0&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2163b0"]])

export default __exports__